import { render, staticRenderFns } from "./ChatMessagesList.vue?vue&type=template&id=e0cd487a&scoped=true"
import script from "./ChatMessagesList.vue?vue&type=script&lang=js"
export * from "./ChatMessagesList.vue?vue&type=script&lang=js"
import style0 from "./ChatMessagesList.vue?vue&type=style&index=0&id=e0cd487a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cd487a",
  null
  
)

export default component.exports